module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Black.69e688f0.ttf";